import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {LoadHotspotResponse} from '../../../model/LoadHotspotResponse';
import {HotspotCreatorService} from '../../../service/http/hotspot-creator.service';

@Component({
  selector: 'app-load-hotspot-template',
  templateUrl: './load-hotspot-template.component.html',
  styleUrls: ['./load-hotspot-template.component.css']
})
export class LoadHotspotTemplateComponent implements OnInit {

  hotspotResponse: LoadHotspotResponse[] = [];
  packageId: number;
  templateName: string;

  displayedColumns: string[] = ['label', 'baseId', 'id', 'found'];

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              public dialogRef: MatDialogRef<LoadHotspotTemplateComponent>,
              private hotspotCreatorService: HotspotCreatorService) { }

  ngOnInit() {
    this.packageId = this.data.packageId,
    this.hotspotResponse = this.data.data;
    this.templateName = this.data.templateName;
  }

  addHotspots() {
    this.hotspotCreatorService.loadTemplate(this.packageId, this.templateName).subscribe(data => {
      this.dialogRef.close();
    });
  }

  cancel() {
    this.dialogRef.close();
  }

}
